var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "info-view" },
    [
      _c("crawl-confirm-dialog", {
        attrs: {
          visible: _vm.crawlConfirmDialogVisible,
          "spider-id": _vm.spiderForm._id
        },
        on: {
          close: function($event) {
            _vm.crawlConfirmDialogVisible = false
          }
        }
      }),
      _c(
        "el-row",
        [
          _c(
            "el-form",
            {
              ref: "spiderForm",
              staticClass: "spider-form",
              attrs: {
                "label-width": "150px",
                model: _vm.spiderForm,
                "label-position": "right"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Spider ID") } },
                [
                  _c("el-input", {
                    attrs: { placeholder: _vm.$t("Spider ID"), disabled: "" },
                    model: {
                      value: _vm.spiderForm._id,
                      callback: function($$v) {
                        _vm.$set(_vm.spiderForm, "_id", $$v)
                      },
                      expression: "spiderForm._id"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Spider Name") } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: _vm.$t("Spider Name"),
                      disabled: _vm.isView || _vm.isPublic
                    },
                    model: {
                      value: _vm.spiderForm.display_name,
                      callback: function($$v) {
                        _vm.$set(_vm.spiderForm, "display_name", $$v)
                      },
                      expression: "spiderForm.display_name"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("Project"),
                    prop: "project_id",
                    required: ""
                  }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: _vm.$t("Project"),
                        filterable: "",
                        disabled: _vm.isView || _vm.isPublic
                      },
                      model: {
                        value: _vm.spiderForm.project_id,
                        callback: function($$v) {
                          _vm.$set(_vm.spiderForm, "project_id", $$v)
                        },
                        expression: "spiderForm.project_id"
                      }
                    },
                    _vm._l(_vm.projectList, function(p) {
                      return _c("el-option", {
                        key: p._id,
                        attrs: { value: p._id, label: p.name }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Source Folder") } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: _vm.$t("Source Folder"),
                      disabled: ""
                    },
                    model: {
                      value: _vm.spiderForm.src,
                      callback: function($$v) {
                        _vm.$set(_vm.spiderForm, "src", $$v)
                      },
                      expression: "spiderForm.src"
                    }
                  })
                ],
                1
              ),
              _vm.spiderForm.type === "customized"
                ? [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("Execute Command"),
                          prop: "cmd",
                          required: "",
                          "inline-message": true
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            placeholder: _vm.$t("Execute Command"),
                            disabled:
                              _vm.isView ||
                              _vm.spiderForm.is_scrapy ||
                              _vm.isPublic
                          },
                          model: {
                            value: _vm.spiderForm.cmd,
                            callback: function($$v) {
                              _vm.$set(_vm.spiderForm, "cmd", $$v)
                            },
                            expression: "spiderForm.cmd"
                          }
                        })
                      ],
                      1
                    )
                  ]
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Results Collection"), prop: "col" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder:
                        _vm.$t("By default: ") + "results_<spider_name>",
                      disabled: _vm.isView || _vm.isPublic
                    },
                    model: {
                      value: _vm.spiderForm.col,
                      callback: function($$v) {
                        _vm.$set(_vm.spiderForm, "col", $$v)
                      },
                      expression: "spiderForm.col"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Spider Type") } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: _vm.$t("Spider Type"),
                        disabled: true,
                        clearable: ""
                      },
                      model: {
                        value: _vm.spiderForm.type,
                        callback: function($$v) {
                          _vm.$set(_vm.spiderForm, "type", $$v)
                        },
                        expression: "spiderForm.type"
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: {
                          value: "configurable",
                          label: _vm.$t("Configurable")
                        }
                      }),
                      _c("el-option", {
                        attrs: {
                          value: "customized",
                          label: _vm.$t("Customized")
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Remark") } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      placeholder: _vm.$t("Remark"),
                      disabled: _vm.isView || _vm.isPublic
                    },
                    model: {
                      value: _vm.spiderForm.remark,
                      callback: function($$v) {
                        _vm.$set(_vm.spiderForm, "remark", $$v)
                      },
                      expression: "spiderForm.remark"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _vm.spiderForm.type === "customized" && !_vm.isView
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("Is Scrapy"),
                                prop: "is_scrapy"
                              }
                            },
                            [
                              _c("el-switch", {
                                attrs: {
                                  "active-color": "#13ce66",
                                  disabled: _vm.isView || _vm.isPublic
                                },
                                on: { change: _vm.onIsScrapyChange },
                                model: {
                                  value: _vm.spiderForm.is_scrapy,
                                  callback: function($$v) {
                                    _vm.$set(_vm.spiderForm, "is_scrapy", $$v)
                                  },
                                  expression: "spiderForm.is_scrapy"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      !_vm.isView
                        ? _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("Is Git"), prop: "is_git" }
                            },
                            [
                              _c("el-switch", {
                                attrs: {
                                  "active-color": "#13ce66",
                                  disabled: _vm.isView || _vm.isPublic
                                },
                                model: {
                                  value: _vm.spiderForm.is_git,
                                  callback: function($$v) {
                                    _vm.$set(_vm.spiderForm, "is_git", $$v)
                                  },
                                  expression: "spiderForm.is_git"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      !_vm.isView
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("Is Long Task"),
                                prop: "is_long_task"
                              }
                            },
                            [
                              _c("el-switch", {
                                attrs: {
                                  "active-color": "#13ce66",
                                  disabled: _vm.isView || _vm.isPublic
                                },
                                model: {
                                  value: _vm.spiderForm.is_long_task,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.spiderForm,
                                      "is_long_task",
                                      $$v
                                    )
                                  },
                                  expression: "spiderForm.is_long_task"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              !_vm.isView
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("De-Duplication"),
                        prop: "dedup_field",
                        rules: _vm.dedupRules
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "center",
                            height: "40px"
                          }
                        },
                        [
                          _c("el-switch", {
                            attrs: {
                              "active-color": "#13ce66",
                              disabled: _vm.isView || _vm.isPublic
                            },
                            on: { change: _vm.onIsDedupChange },
                            model: {
                              value: _vm.spiderForm.is_dedup,
                              callback: function($$v) {
                                _vm.$set(_vm.spiderForm, "is_dedup", $$v)
                              },
                              expression: "spiderForm.is_dedup"
                            }
                          }),
                          _vm.spiderForm.is_dedup
                            ? _c(
                                "el-select",
                                {
                                  staticStyle: {
                                    "margin-left": "20px",
                                    width: "180px"
                                  },
                                  attrs: {
                                    "active-color": "#13ce66",
                                    disabled: _vm.isView || _vm.isPublic
                                  },
                                  model: {
                                    value: _vm.spiderForm.dedup_method,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.spiderForm,
                                        "dedup_method",
                                        $$v
                                      )
                                    },
                                    expression: "spiderForm.dedup_method"
                                  }
                                },
                                [
                                  _c("el-option", {
                                    attrs: {
                                      value: "overwrite",
                                      label: _vm.$t("Overwrite")
                                    }
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      value: "ignore",
                                      label: _vm.$t("Ignore")
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.spiderForm.is_dedup
                            ? _c("el-input", {
                                staticStyle: { "margin-left": "20px" },
                                attrs: {
                                  placeholder: _vm.$t(
                                    "Please enter de-duplicated field"
                                  )
                                },
                                model: {
                                  value: _vm.spiderForm.dedup_field,
                                  callback: function($$v) {
                                    _vm.$set(_vm.spiderForm, "dedup_field", $$v)
                                  },
                                  expression: "spiderForm.dedup_field"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  )
                : _vm._e(),
              !_vm.isView
                ? _c("el-form-item", { attrs: { label: "Web Hook" } }, [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                          height: "40px"
                        }
                      },
                      [
                        _c("el-switch", {
                          attrs: {
                            "active-color": "#13ce66",
                            disabled: _vm.isView || _vm.isPublic
                          },
                          model: {
                            value: _vm.spiderForm.is_web_hook,
                            callback: function($$v) {
                              _vm.$set(_vm.spiderForm, "is_web_hook", $$v)
                            },
                            expression: "spiderForm.is_web_hook"
                          }
                        }),
                        _vm.spiderForm.is_web_hook
                          ? _c("el-input", {
                              staticStyle: { "margin-left": "20px" },
                              attrs: {
                                placeholder: _vm.$t("Please enter Web Hook URL")
                              },
                              model: {
                                value: _vm.spiderForm.web_hook_url,
                                callback: function($$v) {
                                  _vm.$set(_vm.spiderForm, "web_hook_url", $$v)
                                },
                                expression: "spiderForm.web_hook_url"
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      !_vm.isView
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("Is Public"),
                                prop: "is_public"
                              }
                            },
                            [
                              _c("el-switch", {
                                attrs: {
                                  "active-color": "#13ce66",
                                  disabled: _vm.isView || _vm.isPublic
                                },
                                model: {
                                  value: _vm.spiderForm.is_public,
                                  callback: function($$v) {
                                    _vm.$set(_vm.spiderForm, "is_public", $$v)
                                  },
                                  expression: "spiderForm.is_public"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            2
          )
        ],
        1
      ),
      !_vm.isView
        ? _c(
            "el-row",
            { staticClass: "button-container" },
            [
              _vm.isShowRun && !_vm.isPublic
                ? _c(
                    "el-button",
                    {
                      staticStyle: { "margin-right": "10px" },
                      attrs: {
                        size: "small",
                        type: "danger",
                        icon: "el-icon-video-play"
                      },
                      on: { click: _vm.onCrawl }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("Run")) + " ")]
                  )
                : _vm._e(),
              _vm.spiderForm.type === "customized"
                ? _c(
                    "el-upload",
                    {
                      staticStyle: {
                        display: "inline-block",
                        "margin-right": "10px"
                      },
                      attrs: {
                        action:
                          _vm.$request.baseUrl +
                          "/spiders/" +
                          _vm.spiderForm._id +
                          "/upload",
                        headers: { Authorization: _vm.token },
                        "on-progress": function() {
                          return (this$1.uploadLoading = true)
                        },
                        "on-error": _vm.onUploadError,
                        "on-success": _vm.onUploadSuccess,
                        "file-list": _vm.fileList
                      }
                    },
                    [
                      !_vm.isPublic
                        ? _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "loading",
                                  rawName: "v-loading",
                                  value: _vm.uploadLoading,
                                  expression: "uploadLoading"
                                }
                              ],
                              attrs: {
                                size: "small",
                                type: "primary",
                                icon: "el-icon-upload"
                              }
                            },
                            [_vm._v(" " + _vm._s(_vm.$t("Upload")) + " ")]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.isPublic
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        size: "small",
                        type: "success",
                        icon: "el-icon-check"
                      },
                      on: { click: _vm.onSave }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("Save")) + " ")]
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }